<div class="header">
    <h2>{{ 'organisations.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="organisations-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'organisations.fieldset.basic' | translate }}</h2>
        <div class="logo-field">
            <span class="label">{{ 'organisations.form.logo' | translate }}</span>
            @if (form.controls.logoMediaId.value; as logoMediaId) {
                <div class="logo-preview">
                    <app-media-image [mediaId]="logoMediaId" [alt]="'organisations.form.logo' | translate" />
                </div>
            }
            <div class="logo-actions">
                <p-button
                    [label]="(form.controls.logoMediaId.value ? 'organisations.form.changeLogo' : 'organisations.form.selectLogo') | translate"
                    icon="pi pi-image"
                    [outlined]="true"
                    severity="secondary"
                    data-test="organisations-add-select-logo"
                    (onClick)="onSelectLogo()"
                />
                @if (form.controls.logoMediaId.value) {
                    <p-button
                        [label]="'organisations.form.removeLogo' | translate"
                        icon="pi pi-times"
                        [text]="true"
                        severity="secondary"
                        data-test="organisations-add-clear-logo"
                        (onClick)="onClearLogo()"
                    />
                }
            </div>
        </div>
        <app-form-input
            [control]="form.controls.name"
            [label]="'organisations.form.name' | translate"
            [placeholder]="'organisations.form.name.placeholder' | translate"
            inputId="name"
            testId="organisations-add-name"
        />
    </div>

    <div class="section">
        <h2>{{ 'organisations.fieldset.contact' | translate }}</h2>
        <app-form-input
            [control]="form.controls.contactName"
            [label]="'organisations.form.contactName' | translate"
            [placeholder]="'organisations.form.contactName.placeholder' | translate"
            inputId="contactName"
            testId="organisations-add-contact-name"
        />
        <app-form-input
            [control]="form.controls.contactEmail"
            [label]="'organisations.form.contactEmail' | translate"
            [placeholder]="'organisations.form.contactEmail.placeholder' | translate"
            inputId="contactEmail"
            testId="organisations-add-contact-email"
        />
    </div>

    <div class="section">
        <h2>{{ 'organisations.fieldset.schools' | translate }}</h2>
        <app-form-multiselect
            [control]="form.controls.schoolIds"
            [label]="'organisations.form.schools' | translate"
            [placeholder]="'organisations.form.schools.placeholder' | translate"
            [options]="schoolOptions()"
            [filter]="true"
            inputId="schoolIds"
            testId="organisations-add-school-ids"
        />
    </div>
</form>

<div class="footer">
    <p-button
        [label]="'organisations.form.cancel' | translate"
        [outlined]="true"
        severity="secondary"
        data-test="organisations-add-cancel"
        (onClick)="close()"
    />
    <p-button
        type="submit"
        [label]="'organisations.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="organisations-add-submit"
        (onClick)="onSubmit()"
    />
</div>
